function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';
import PropTypes from 'prop-types';
import { InputGroup } from 'module-tsl-ui-elements';
import { Field } from 'formik';

var CustomInputGroup = function CustomInputGroup(_ref) {
  var _ref$field = _ref.field,
      name = _ref$field.name,
      value = _ref$field.value,
      onChange = _ref$field.onChange,
      onBlur = _ref$field.onBlur,
      _ref$form = _ref.form,
      touched = _ref$form.touched,
      errors = _ref$form.errors,
      submitCount = _ref$form.submitCount,
      label = _ref.label;
  return /*#__PURE__*/React.createElement(InputGroup, {
    self: {
      groupId: 'seller-form',
      error: (touched[name] || Boolean(submitCount)) && errors[name]
    },
    label: {
      text: label
    },
    input: {
      name: name,
      value: value,
      placeholder: label,
      onChange: onChange,
      onBlur: onBlur
    }
  });
};

CustomInputGroup.displayName = "CustomInputGroup";
CustomInputGroup.propTypes = {
  field: PropTypes.objectOf(PropTypes.shape({
    name: PropTypes.string.isRequired,
    onChange: PropTypes.func,
    onBlur: PropTypes.func
  })).isRequired,
  form: PropTypes.objectOf(PropTypes.shape({
    touched: PropTypes.object,
    errors: PropTypes.array,
    submitCount: PropTypes.number
  })).isRequired,
  label: PropTypes.string.isRequired
};

var EnhancedInputGroup = function EnhancedInputGroup(props) {
  return /*#__PURE__*/React.createElement(Field, _extends({
    component: CustomInputGroup
  }, props));
};

EnhancedInputGroup.displayName = "EnhancedInputGroup";
export default EnhancedInputGroup;